/**
 * SkipToMain — link de acessibilidade que aparece apenas com foco do
 * teclado (Tab). Permite pular header e ir direto pro conteúdo.
 *
 * Requer que a área de conteúdo principal tenha id="main-content".
 *
 * Padrão WCAG 2.1 — bypass blocks (técnica G1).
 */
export function SkipToMain() {
  return (
    <a
      href="#main-content"
      className="focus:bg-primary focus:text-primary-foreground focus:ring-ring sr-only focus:not-sr-only focus:fixed focus:left-2 focus:top-2 focus:z-50 focus:rounded-md focus:px-3 focus:py-2 focus:text-sm focus:font-semibold focus:shadow-lg focus:outline-none focus:ring-2 focus:ring-offset-2"
    >
      Pular para o conteúdo principal
    </a>
  );
}
